import { Field, Form, Formik } from "formik";
import Cookies from "js-cookie";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { object, string } from "yup";

import Button from "components/lib/Shared/Button";
import Input from "components/lib/Shared/Input";
import { editSubscriptionAsync } from "state/slices/subscription";

const validationSchema = object().shape({
  subscribersLimit: string().required("Number of subscribers is required"),
});

const NumberOfSubscribers = ({ resetSubscription }) => {
  const cookieRole = Cookies.get("role");
  const dispatch = useDispatch();
  const [showAddFeature, setShowFeature] = useState(false);
  const [selectedFeature, setSelectedFeature] = useState("");
  const { selectedSubscription, updatingFeatures, deletingFeatures } =
    useSelector((state) => state.subscriptionSlice);

  const handleSubmit = async (data) => {
    const res = await dispatch(
      editSubscriptionAsync({
        subscriptionId: selectedSubscription?._id,
        data: {
          ...data,
        },
      })
    );
    await resetSubscription();
  };
  return (
    <Formik
      enableReinitialize
      initialValues={{
        subscribersLimit: selectedSubscription?.subscribersLimit ?? 1,
      }}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting, errors, values }) => {
        return (
          <Form className="text-sm w-full">
            <div className="shadow sm:rounded-md sm:overflow-hidden">
              <div className="bg-white py-6 px-4 space-y-6 sm:p-6">
                <div className="flex justify-between items-start gap-6">
                  <div className="flex-grow">
                    <Field
                      component={Input}
                      name="subscribersLimit"
                      type="number"
                      placeholder="Number of subscribers"
                    />
                  </div>
                  <div className="flex items-center justify-end gap-x-4 mt-1">
                    <Button
                      disabled={isSubmitting}
                      variant="secondary"
                      onClick={() => setShowFeature(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      loadingText="Saving..."
                      isLoading={isSubmitting}
                    >
                      Save
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default NumberOfSubscribers;
